// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{font-size:24px;height:24px;width:24px}.icon--lg{font-size:48px;height:48px;width:48px}.icon--md{font-size:36px;height:36px;width:36px}.icon--sm{font-size:14px;height:14px;width:14px}.icon--xl{font-size:72px;height:72px;width:72px}.icon--xxl{font-size:96px;height:96px;width:96px}", ""]);
// Exports
module.exports = exports;
